export * from './body-input-modal.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/body-input-modal/index.ts